import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withInterceptors} from '@angular/common/http'
import localeSvExtra from '@angular/common/locales/extra/sv'
import localeSv from '@angular/common/locales/sv'
import {ApplicationConfig} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideRouter, withHashLocation} from '@angular/router'
import routes from './app-routes'
import {ENVIRONMENT, WINDOW} from './application/injection-tokens'
import {environment} from '../environments/environment'
import {responseInterceptor} from '@sparbanken-syd/sparbanken-syd-bankid'

registerLocaleData(localeSv, 'sv', localeSvExtra)


export const appConfig: ApplicationConfig = {
  providers: [
    {provide: WINDOW, useValue: globalThis},
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline',
        subscriptSizing: 'dynamic'
      }
    },
    {provide: ENVIRONMENT, useValue: environment},
    provideHttpClient(
      withInterceptors([responseInterceptor])
    ),
    provideRouter(routes,
      withHashLocation())
  ]
}